module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_1@2x.c9dbbe8e.png";